import uiTagManager from './tag-manager'
import uiTagManagerConfiguration from './tag-manager/configuration'

export { 
    uiTagManager,
    uiTagManagerConfiguration,
}
